import {
    CANCEL_RUN,
    CREATE_RUN,
    CREATE_RUN_FAIL,
    CREATE_RUN_SUCCESS,
    DELETE_RUN,
    FETCH_RUN_FAIL,
    FETCH_RUN_RETRY,
    FETCH_RUN_RESULTS_FAIL,
    FETCH_RUN_RESULTS_SUCCESS,
    FETCH_RUN_SUCCESS,
    FETCH_RUN_TO_COPY,
    FETCH_RUN_TO_COPY_FAIL,
    FETCH_RUN_TO_COPY_SUCCESS,
    FETCH_RUNS,
    FETCH_RUNS_FAIL,
    FETCH_RUNS_GAVE_UP,
    FETCH_RUNS_RETRY,
    FETCH_RUNS_SUCCESS,
    FETCH_SCENARIOS,
    FETCH_SCENARIOS_FAIL,
    FETCH_SCENARIOS_SUCCESS,
    FETCH_SIMULATION_LIMITS,
    FETCH_SIMULATION_LIMITS_FAIL,
    FETCH_SIMULATION_LIMITS_SUCCESS,
    FOLLOW_RUN,
    FOLLOW_RUNS_LIST,
    RUN_ACTION_FAIL,
    RUN_ACTION_SUCCESS,
    STOP_FOLLOWING_RUN,
    STOP_FOLLOWING_RUNS_LIST
} from './actionTypes';

export const fetchRuns = args => ({
    type: FETCH_RUNS,
    payload: args || {}
});

export const fetchRunsSuccess = response => ({
    type: FETCH_RUNS_SUCCESS,
    payload: response
});

export const fetchRunsFail = error => ({
    type: FETCH_RUNS_FAIL,
    payload: error
});

export const followRunsList = () => ({
    type: FOLLOW_RUNS_LIST
});

export const stopFollowingRunsList = () => ({
    type: STOP_FOLLOWING_RUNS_LIST
});

/* A read of the list that failed and will be tried again */
export const fetchRunsRetry = () => ({
    type: FETCH_RUNS_RETRY
});

/* Reads of the list that failed in a row: it is not followed any more */
export const fetchRunsGaveUp = error => ({
    type: FETCH_RUNS_GAVE_UP,
    payload: error
});

export const fetchScenarios = () => ({
    type: FETCH_SCENARIOS
});

export const fetchScenariosSuccess = response => ({
    type: FETCH_SCENARIOS_SUCCESS,
    payload: response
});

export const fetchScenariosFail = error => ({
    type: FETCH_SCENARIOS_FAIL,
    payload: error
});

export const fetchSimulationLimits = () => ({
    type: FETCH_SIMULATION_LIMITS
});

export const fetchSimulationLimitsSuccess = response => ({
    type: FETCH_SIMULATION_LIMITS_SUCCESS,
    payload: response
});

export const fetchSimulationLimitsFail = error => ({
    type: FETCH_SIMULATION_LIMITS_FAIL,
    payload: error
});

/* args: { workspace, seed?, label?, scenarios: [{ id, parameters? }] } */
export const createRun = args => ({
    type: CREATE_RUN,
    payload: args
});

export const createRunSuccess = response => ({
    type: CREATE_RUN_SUCCESS,
    payload: response
});

export const createRunFail = error => ({
    type: CREATE_RUN_FAIL,
    payload: error
});

export const followRun = ({ runId }) => ({
    type: FOLLOW_RUN,
    payload: { runId }
});

export const stopFollowingRun = () => ({
    type: STOP_FOLLOWING_RUN
});

export const fetchRunSuccess = run => ({
    type: FETCH_RUN_SUCCESS,
    payload: run
});

export const fetchRunFail = error => ({
    type: FETCH_RUN_FAIL,
    payload: error
});

/* A read of the run that failed and will be tried again */
export const fetchRunRetry = () => ({
    type: FETCH_RUN_RETRY
});

export const fetchRunToCopy = ({ runId }) => ({
    type: FETCH_RUN_TO_COPY,
    payload: { runId }
});

export const fetchRunToCopySuccess = run => ({
    type: FETCH_RUN_TO_COPY_SUCCESS,
    payload: run
});

export const fetchRunToCopyFail = error => ({
    type: FETCH_RUN_TO_COPY_FAIL,
    payload: error
});

export const fetchRunResultsSuccess = results => ({
    type: FETCH_RUN_RESULTS_SUCCESS,
    payload: results
});

export const fetchRunResultsFail = error => ({
    type: FETCH_RUN_RESULTS_FAIL,
    payload: error
});

export const cancelRun = ({ runId }) => ({
    type: CANCEL_RUN,
    payload: { runId }
});

/* redirect: go back to the list of runs once it is deleted, for a run that was deleted from its own screen */
export const deleteRun = ({ runId, redirect = false }) => ({
    type: DELETE_RUN,
    payload: { runId, redirect }
});

export const runActionSuccess = ({ runId }) => ({
    type: RUN_ACTION_SUCCESS,
    payload: { runId }
});

export const runActionFail = ({ runId, error }) => ({
    type: RUN_ACTION_FAIL,
    payload: { runId, error }
});
